import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=b1758cc2&scoped=true&"
import script from "./bill.vue?vue&type=script&lang=js&"
export * from "./bill.vue?vue&type=script&lang=js&"
import style0 from "./bill.vue?vue&type=style&index=0&id=b1758cc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1758cc2",
  null
  
)

export default component.exports